import { BaseLookup } from "./base.lookup";

// ids are the job status ksuids, matching the lookup ids returned on JobDto
export class JobStatusTypesLookup extends BaseLookup {

    // Values
    static readonly PENDING = new JobStatusTypesLookup('job_status_type_38g9PclCnu5wjjYH10EjlEKrn22', 'Pending');
    static readonly RUNNING = new JobStatusTypesLookup('job_status_type_38g9Pc4ZOCOTxMInnmNzV7k1Wsf', 'Running');
    static readonly COMPLETED = new JobStatusTypesLookup('job_status_type_38g9PZFQg49s0n7v8MLTTWC7UH9', 'Completed');
    static readonly FAILED = new JobStatusTypesLookup('job_status_type_38g9PesDHZx0dDw1JbR9OBfrr9K', 'Failed');
    static readonly CANCELLED = new JobStatusTypesLookup('job_status_type_38g9PamJlmVZjrAHPYbHNwVs02C', 'Cancelled');
    static readonly DEAD_LETTER = new JobStatusTypesLookup('job_status_type_38g9Pcb3fu78Myc8g8uMSaI9omB', 'Dead Letter');
    static readonly INTERRUPTED = new JobStatusTypesLookup('job_status_type_3H8ejLxR66hgRc8sA0JkIAXknOT', 'Interrupted');

    static readonly values = [
      JobStatusTypesLookup.PENDING,
      JobStatusTypesLookup.RUNNING,
      JobStatusTypesLookup.COMPLETED,
      JobStatusTypesLookup.FAILED,
      JobStatusTypesLookup.CANCELLED,
      JobStatusTypesLookup.DEAD_LETTER,
      JobStatusTypesLookup.INTERRUPTED,
    ]
  }
